import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";
import React from "react";

const RegistrationDoc: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>EBFA Registration Document | Ashridge Park FC</title>
        <meta name="description" content="Download the EBFA registration document for Ashridge Park Football Club." />
      </Helmet>
      
      <Container className="p-3 my-4">
        <h1 className="mb-4">EBFA REGISTRATION DOCUMENT</h1>
        <p className="mb-4">
          You can download the EBFA registration document for Ashridge Park Football Club by clicking the link below:
        </p>
        <a href="/content/GotSport-EBFA-only-registration.docx" download className="btn btn-primary">
          Download EBFA Registration Document
        </a>
      </Container>
    </>
  );
}

export default RegistrationDoc;